import { RefObject, useEffect } from "react";
import { addUserEventSourceListener } from "@/common/hooks/event-source/useUserApiEventSource.ts";
import { USER_EVENT_SHARED_SEGMENT } from "@/common/sse-api-event-source-message-types";
import { emitEvent } from "@/services/event-emitter.ts";
import { EventTypes } from "@/types/types.ts";
import { SnackbarEventTypes } from "@/enum/snackbarEventTypes.ts";

function useUserEventSharedSegment(eventSourceRef: RefObject<EventSource | null>) {

  // USER_EVENT_SHARED_SEGMENT Listener
  useEffect(() => {
    if (!eventSourceRef.current) return;

    const handleUserEventSharedSegment = (e: MessageEvent) => {
      const data = JSON.parse(e.data);
      emitEvent(EventTypes.USER_EVENT_SHOW_SNACKBAR, {
        type: SnackbarEventTypes.USER_EVENT_SHARED_SEGMENT,
        data: {
          segment: data.segment,
          track: data.track,
          message: data.message,
        },
        eventCreatedByUser: data.user,
        uniqueTabId: data.uniqueTabId,
      });
    };

    const removeListener = addUserEventSourceListener(
      eventSourceRef.current,
      USER_EVENT_SHARED_SEGMENT,
      handleUserEventSharedSegment,
    );

    // Cleanup
    return () => {
      removeListener();
    };
  }, [eventSourceRef]);
}

export default useUserEventSharedSegment;
